<template>
  <div class="wrapper text-left">
    <div class="bg-card">
      <h1 class="mb-0">
        {{ $t('pages.my-applications.title', 'Applications') }}
      </h1>
      <p>{{ $t('pages.my-applications.subtitle', 'Updates on the status of your applications') }}</p>

      <div class="text-left mb-2">
        <span style="font-size: 0.8rem;">{{ $t('pages.my-applications.total-label', 'Total applications:') }}</span> {{ paginationMeta ? paginationMeta.total : "" }}
      </div>
      <pagination
        v-if="paginationMeta"
        :data="paginationMeta"
        size="small"
        :limit="1"
        align="center"
        class="mb-2"
        @pagination-change-page="getResults"
      />
      <div
        v-for="offerApply in offersApplyList"
        :key="offerApply.id"
      >
        <offerApplyCard :offer-apply="offerApply" />
      </div>
      <pagination
        v-if="paginationMeta"
        :data="paginationMeta"
        size="small"
        :limit="1"
        align="center"
        @pagination-change-page="getResults"
      />
      <div v-if="offersApplyList.length === 0">
        {{ $t('pages.my-applications.no-applications', 'No applications yet') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import offerApplyCard from '@/components/jobs/blocks/offerApplyCard';

export default {
  components: {
    offerApplyCard
  },
  data() {
    return {
      paginationMeta: null
    }
  },
  computed: {
    ...mapGetters('offersApply', {
      offersApplyLoading: 'isLoading',
      offersApplyList: 'list'
    }),

    ...mapState([
      'route', // vuex-router-sync
    ]),
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions('offersApply', {
      fetchOffersApply: 'fetchList',
      destroyOffer: 'destroy'
    }),
    fetchData() {
      return this.fetchOffersApply({ customUrl: '/offerApply/myOffers' })
        .then(response => { this.paginationMeta = response.meta })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },
    getResults(page){
      const config = {
        params: {
          page: page
        },
      };

      this.$store.dispatch('offersApply/fetchList', { config })
        .then((res) => {
          this.paginationMeta = res.meta;
          window.scrollTo(0,0);
        })
    }
  }
}
</script>
